import ThreeDotMenu from './three-dot-menu';

export default ThreeDotMenu;
